import { Link } from "react-router-dom";
import Marquee from "../components/Marquee";
import Hero from "../components/home/Hero";
import ServicesGrid from "../components/home/ServicesGrid";
import Trust from "../components/home/Trust";
import Area from "../components/home/Area";
import HowItWorks from "../components/home/HowItWorks";
import Testimonials from "../components/home/Testimonials";
import SectionHead from "../components/SectionHead";
import FAQAccordion from "../components/FAQAccordion";
import ContactForm from "../components/ContactForm";
import { Reveal } from "../components/motion";
import { useLang } from "../i18n";

const Home = () => {
    const { t } = useLang();
    return (
        <main>
            <Hero />
            <Marquee />

            <section id="servicios" className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <SectionHead
                        eyebrow={t.home.servicesEyebrow}
                        title={t.home.servicesTitle}
                        sub={t.home.servicesSub}
                        testid="services-title"
                    />
                    <Reveal delay={0.1}>
                        <Link
                            to="/servicios"
                            data-testid="services-view-all"
                            className="text-sm font-bold text-terracotta underline-offset-4 transition-colors hover:text-terracotta-dark hover:underline"
                        >
                            {t.home.viewAll}
                        </Link>
                    </Reveal>
                </div>
                <ServicesGrid />
            </section>

            <Trust />
            <Area />
            <HowItWorks />
            <Testimonials />

            <section className="mx-auto max-w-4xl px-5 py-20 sm:px-8 lg:py-24">
                <SectionHead
                    eyebrow={t.home.faqEyebrow}
                    title={t.home.faqTitle}
                    testid="faq-title"
                    align="center"
                />
                <FAQAccordion limit={6} />
                <Reveal className="mt-6 text-center">
                    <Link to="/faq" className="text-sm font-bold text-terracotta underline-offset-4 hover:underline">
                        {t.home.faqViewAll}
                    </Link>
                </Reveal>
            </section>

            <section data-testid="contact-section" className="bg-sand/40">
                <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
                    <div className="grid gap-12 lg:grid-cols-12">
                        <div className="lg:col-span-5">
                            <SectionHead
                                eyebrow={t.contact.eyebrow}
                                title={t.contact.title}
                                sub={t.contact.sub}
                                testid="contact-title"
                            />
                            <Reveal delay={0.15}>
                                <p className="mt-6 text-sm leading-relaxed text-[#525B53]">
                                    {t.contact.note}
                                </p>
                            </Reveal>
                        </div>
                        <Reveal delay={0.1} className="lg:col-span-7">
                            <div className="rounded-[2rem] border border-[#E3DCCF] bg-white p-6 shadow-sm sm:p-9">
                                <ContactForm />
                            </div>
                        </Reveal>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Home;
